// extracted by mini-css-extract-plugin
export var compactFilters = "_gk-4";
export var detailImage = "_gk-1";
export var dropdownContainer = "_gk-2";
export var imageContainer = "_gk-0";
export var selectedCard = "_gk-3";